/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAggregate1 } from './UserAggregate1';
import {
    UserAggregate1FromJSON,
    UserAggregate1FromJSONTyped,
    UserAggregate1ToJSON,
    UserAggregate1ToJSONTyped,
} from './UserAggregate1';
import type { Token } from './Token';
import {
    TokenFromJSON,
    TokenFromJSONTyped,
    TokenToJSON,
    TokenToJSONTyped,
} from './Token';

/**
 * 
 * @export
 * @interface MiniAppBusinessSessionResponse
 */
export interface MiniAppBusinessSessionResponse {
    /**
     * 
     * @type {UserAggregate1}
     * @memberof MiniAppBusinessSessionResponse
     */
    user: UserAggregate1;
    /**
     * 
     * @type {Token}
     * @memberof MiniAppBusinessSessionResponse
     */
    token: Token;
    /**
     * BI business resolved from the verified Foodics whoami identity. Access and refresh tokens remain restricted to this business.
     * @type {string}
     * @memberof MiniAppBusinessSessionResponse
     */
    businessId: string;
}

/**
 * Check if a given object implements the MiniAppBusinessSessionResponse interface.
 */
export function instanceOfMiniAppBusinessSessionResponse(value: object): value is MiniAppBusinessSessionResponse {
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('businessId' in value) || value['businessId'] === undefined) return false;
    return true;
}

export function MiniAppBusinessSessionResponseFromJSON(json: any): MiniAppBusinessSessionResponse {
    return MiniAppBusinessSessionResponseFromJSONTyped(json, false);
}

export function MiniAppBusinessSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MiniAppBusinessSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'user': UserAggregate1FromJSON(json['user']),
        'token': TokenFromJSON(json['token']),
        'businessId': json['businessId'],
    };
}

export function MiniAppBusinessSessionResponseToJSON(json: any): MiniAppBusinessSessionResponse {
    return MiniAppBusinessSessionResponseToJSONTyped(json, false);
}

export function MiniAppBusinessSessionResponseToJSONTyped(value?: MiniAppBusinessSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': UserAggregate1ToJSON(value['user']),
        'token': TokenToJSON(value['token']),
        'businessId': value['businessId'],
    };
}

